var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editor",class:{ ace_disabled: _vm.disabled },style:(_vm.maxHeight !== Infinity ? ("minHeight: " + _vm.maxHeight + "px") : '')})}
var staticRenderFns = []

export { render, staticRenderFns }